module.exports = __webpack_public_path__ + "static/media/landing_shot0.b2662068.jpg";